const VideoActionTypes = {
  LOAD_VIDEOS:      'LOAD_VIDEOS',
  LOAD_VIDEOS_DONE: 'LOAD_VIDEOS_DONE',
  LOAD_VIDEOS_FAIL: 'LOAD_VIDEOS_FAIL',

  LOAD_LIBRARY_VIDEOS:      'LOAD_LIBRARY_VIDEOS',
  LOAD_LIBRARY_VIDEOS_DONE: 'LOAD_LIBRARY_VIDEOS_DONE',
  LOAD_LIBRARY_VIDEOS_FAIL: 'LOAD_LIBRARY_VIDEOS_FAIL',

  LOAD_TRASHED_VIDEOS:      'LOAD_TRASHED_VIDEOS',
  LOAD_TRASHED_VIDEOS_DONE: 'LOAD_TRASHED_VIDEOS_DONE',
  LOAD_TRASHED_VIDEOS_FAIL: 'LOAD_TRASHED_VIDEOS_FAIL',

  LOAD_VIDEO:      'LOAD_VIDEO',
  LOAD_VIDEO_DONE: 'LOAD_VIDEO_DONE',
  LOAD_VIDEO_FAIL: 'LOAD_VIDEO_FAIL',

  CREATE_VIDEO:      'CREATE_VIDEO',
  CREATE_VIDEO_DONE: 'CREATE_VIDEO_DONE',
  CREATE_VIDEO_FAIL: 'CREATE_VIDEO_FAIL',

  UPDATE_VIDEO:      'UPDATE_VIDEO',
  UPDATE_VIDEO_DONE: 'UPDATE_VIDEO_DONE',
  UPDATE_VIDEO_FAIL: 'UPDATE_VIDEO_FAIL',

  DELETE_VIDEO:      'DELETE_VIDEO',
  DELETE_VIDEO_DONE: 'DELETE_VIDEO_DONE',
  DELETE_VIDEO_FAIL: 'DELETE_VIDEO_FAIL',

  RESTORE_VIDEO:      'RESTORE_VIDEO',
  RESTORE_VIDEO_DONE: 'RESTORE_VIDEO_DONE',
  RESTORE_VIDEO_FAIL: 'RESTORE_VIDEO_FAIL',

  PERMANENT_DELETE_VIDEO:      'PERMANENT_DELETE_VIDEO',
  PERMANENT_DELETE_VIDEO_DONE: 'PERMANENT_DELETE_VIDEO_DONE',
  PERMANENT_DELETE_VIDEO_FAIL: 'PERMANENT_DELETE_VIDEO_FAIL',

  BULK_UPDATE_VIDEOS:      'BULK_UPDATE_VIDEOS',
  BULK_UPDATE_VIDEOS_DONE: 'BULK_UPDATE_VIDEOS_DONE',
  BULK_UPDATE_VIDEOS_FAIL: 'BULK_UPDATE_VIDEOS_FAIL',

  BULK_DELETE_VIDEOS:      'BULK_DELETE_VIDEOS',
  BULK_DELETE_VIDEOS_DONE: 'BULK_DELETE_VIDEOS_DONE',
  BULK_DELETE_VIDEOS_FAIL: 'BULK_DELETE_VIDEOS_FAIL',

  BULK_RESTORE_TRASH_VIDEOS:      'BULK_RESTORE_TRASH_VIDEOS',
  BULK_RESTORE_TRASH_VIDEOS_DONE: 'BULK_RESTORE_TRASH_VIDEOS_DONE',
  BULK_RESTORE_TRASH_VIDEOS_FAIL: 'BULK_RESTORE_TRASH_VIDEOS_FAIL',

  BULK_DELETE_TRASH_VIDEOS:      'BULK_DELETE_TRASH_VIDEOS',
  BULK_DELETE_TRASH_VIDEOS_DONE: 'BULK_DELETE_TRASH_VIDEOS_DONE',
  BULK_DELETE_TRASH_VIDEOS_FAIL: 'BULK_DELETE_TRASH_VIDEOS_FAIL',
};

export default VideoActionTypes;
